import baseSimulator from "./baseSimulator";
import PzSimulators from "@/components/Flujo/Templates/PzSimulatorsTemplate";
import PzSimulatorsTemplate from "@/components/Flujo/Templates/PzSimulatorsTemplate";
import currency from "@/commons/filters/other/currency";
import { Money } from 'v-money';
export default {
  name: 'PzVehiculoSimulator',
  components: {
    PzSimulatorsTemplate: PzSimulatorsTemplate,
    PzSimulators: PzSimulators,
    Money: Money
  },
  mixins: [baseSimulator],
  computed: {
    valor_prestamo: function valor_prestamo() {
      var vehiculo = this.form.valor_vehiculo ? this.form.valor_vehiculo : 0;
      var entrega_inicial = this.form.entrega_inicial ? this.form.entrega_inicial : 0;
      var valor = parseFloat(vehiculo) - parseFloat(entrega_inicial);
      this.form.monto = valor;
      return this.formatTooltip(valor);
    }
  },
  data: function data() {
    return {
      vehiculo: true,
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    };
  },
  created: function created() {
    this.form.monto = 0;
    this.form.linea_otorgar_porc = 0;
    this.emitChange();
  },
  methods: {
    formatTooltip: function formatTooltip(val) {
      if (val != null) return currency(val, '', 0);
    }
  }
};